import { axiosInstance } from '@/utils/lib/axios';
import { env } from '@/utils/constants/env';

const BASE = `${env.apiTasklistBaseUrl}/api/v1/compro/kpi-templates`;
const MEDIA_BASE = `${env.apiTasklistBaseUrl}/api/v1/compro/media`;

export async function getMyKpis(tenantId: string | number, params?: Record<string, unknown> | null) {
  const { data } = await axiosInstance.get(`${BASE}/tenant/${tenantId}/my-kpi`, { params });
  return data;
}

export async function getMyKpiDetail(tenantId: string | number, id: string | number) {
  const { data } = await axiosInstance.get(`${BASE}/tenant/${tenantId}/my-kpi/${id}`);
  return data;
}

export async function updateMyKpiRealization(tenantId: string | number, id: string | number, payload: any) {
  const { data } = await axiosInstance.put(`${BASE}/tenant/${tenantId}/my-kpi/${id}`, payload);
  return data;
}

export async function submitMyKpi(tenantId: string | number, templateId: string | number) {
  const { data } = await axiosInstance.post(`${BASE}/tenant/${tenantId}/my-kpi/submit/${templateId}`);
  return data;
}

export async function uploadKpiEvidence(itemId: number, file: File) {
  const formData = new FormData();
  formData.append('file', file, file.name);
  formData.append('model_type', 'UserKPIItem');
  formData.append('model_id', String(itemId));
  formData.append('collection_name', 'kpi_evidence');

  const { data } = await axiosInstance.post(`${MEDIA_BASE}/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    transformRequest: [d => d],
  });
  return data;
}

export async function deleteKpiEvidence(mediaId: number) {
  const { data } = await axiosInstance.delete(`${MEDIA_BASE}/${mediaId}`);
  return data;
}

export async function getKpiApprovals(tenantId: string | number, params?: Record<string, unknown> | null) {
  const { data } = await axiosInstance.get(`${BASE}/tenant/${tenantId}/kpi-approval`, { params });
  return data;
}

export async function getKpiApprovalDetail(tenantId: string | number, id: string | number) {
  const { data } = await axiosInstance.get(`${BASE}/tenant/${tenantId}/kpi-approval/${id}`);
  return data;
}

export async function updateKpiApproval(
  tenantId: string | number,
  id: string | number,
  payload: { status: string; notes_manager?: string },
) {
  const { data } = await axiosInstance.put(`${BASE}/tenant/${tenantId}/kpi-approval/${id}`, payload);
  return data;
}

export async function updateKpiApprovalItems(
  tenantId: string | number,
  id: string | number,
  items: { source_item_id: number; manager_actual: number }[],
) {
  const { data } = await axiosInstance.put(`${BASE}/tenant/${tenantId}/kpi-approval/${id}/items`, { items });
  return data;
}
